import { createFeature, createReducer, on } from "@ngrx/store";
import { ProtocolScope, ProtocolState } from "./protocol.state";
import { protocolPanelActions } from "./protocol.actions";

const initialState: ProtocolState = {
  scope: ProtocolScope.Asset,
  methodTypeId: undefined,
};

const reducer = createReducer(
  initialState,
  on(protocolPanelActions.setScope, (state, { scope }) => ({ ...state, scope })),
  on(protocolPanelActions.selectSampleSuccess, (state, { methodType }) => ({ ...state, methodTypeId: methodType })),
);

export const protocolFeature = createFeature({
  name: "protocolPanel",
  reducer,
});
